<template>
  <EbLabel :disabled="disabled" :forId="uid" class="eb-checkbox-label" :class="{'eb-checkbox-label-withLabelAfter': labelAfter}" :text="label" :required="required" :labelAfter="labelAfter">
    <input :id="uid" type="checkbox" :checked="isChecked" :value="value" @change="onInput($event.target.checked)" :disabled="disabled" :required="required"/>
    <span class="checkmark" :class="[labelAfter ? 'checkmark-before' : 'checkmark-after']" />
  </EbLabel>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    value: {
      default: 0,
    },
    required: {
      type: Boolean,
      default: false,
    },
    labelAfter: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uid: null
    }
  },
  mounted() {
    this.uid = `uid_${this._uid}`
  },
  computed: {
    isChecked: function() {
      return this.value
    },
  },
  methods: {
    onInput(value) {
      this.$emit('input', value)
    },
  },
}
</script>

<style lang="scss" scoped>
.eb-checkbox-label {
  &:focus-within {
    background-color: $eb-color-blue-lighter;
    input ~ .checkmark {
      outline: $eb-border-l solid $eb-color-blue-secondary;
    }
  }
  
  input:checked ~ .checkmark {
    background-color: $eb-color-blue-secondary;
  }
  
  input:checked ~ .checkmark:after {
    display: block;
  }
  
  .checkmark {
    height: 24px;
    width: 24px;
    background-color: $white;
    border: 1px solid $eb-color-gray-600;
    box-shadow: box-shadow-size(1);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    &:after {
      content: '';
      display: none;
    }
  }
  
  .checkmark:after {
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 $eb-border-m $eb-border-m 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  
  .checkmark-after {
    margin-left: $eb-space-default;
  }
  .checkmark-before {
    order: -1;
    margin-right: $eb-space-default;
    flex: none;
  }
  
  input[disabled] ~ .checkmark {
    background-color: $eb-color-gray-100;
    cursor: not-allowed;
  }
}
</style>
